import React, { useEffect, useState } from "react";
import "./Blog.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { FiSearch, FiHeadphones } from "react-icons/fi";
import { FaRegHandshake, FaHeart } from "react-icons/fa";
import { GiMeditation, GiLotus, GiTempleGate } from "react-icons/gi";
import { useAuth } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FaCalculator, FaArrowRight, FaGem } from "react-icons/fa";
const API_BASE_URL = "https://astrologicalsolutions.astrologicalsolutions.in";
const features = [
  {
    icon: <FaRegHandshake />,
    title: "Authentic Knowledge",
    desc: "Well-researched & trusted content",
  },
  {
    icon: <GiMeditation />,
    title: "Expert Guidance",
    desc: "Insights from Vedic experts",
  },
  {
    icon: <GiLotus />,
    title: "Spiritual Growth",
    desc: "Awaken your inner self",
  },
  {
    icon: <FaHeart />,
    title: "Healthy Lifestyle",
    desc: "Mind, body & soul balance",
  },
  {
    icon: <GiTempleGate />,
    title: "Cultural Heritage",
    desc: "Rooted in ancient wisdom",
  },
];
const popularBlogs = [
  {
    id: 1,
    tag: "Rudraksha Calculator",
    title: "1 Mukhi Rudraksha: Who Should Wear It and Who Should Avoid It?",
    author: "Astro Logical Solutions",
    date: "13 Oct, 2026",
    slug: "https://astrologicalsolutions.in/blog/8fba332c-eb5a-4b1a-b087-6e680add48da",
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/f_auto,q_auto,w_1600/v1791891527/beffdd10-176c-4d14-a6a6-abbafcd54ce0_n13ppj.png",
  },
  {
    id: 2,
    tag: "1 Mukhi Rudraksha",
    title: "How to Identify an Original 1 Mukhi Rudraksha: 7 Things to Check",
    author: "Astro Logical Solutions",
    date: "28 Oct, 2026",
    slug: "https://astrologicalsolutions.in/blog/34e0b5fc-6c7b-49b3-98c7-f28c9325b791",
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1793182369/66904384-8608-4403-8a93-9b8dc5d971c2_rfy1lv.png",
  },
   {
    id: 3,
    tag: "1 Mukhi Rudraksha",
    title: "How to Wear 1 Mukhi Rudraksha: Mantra & Rituals",
    author: "Astro Logical Solutions",
    date: "29 Oct, 2026",
    slug: "https://astrologicalsolutions.in/blog/440f4e4e-0a83-40b8-b4c7-e1775dfea6a5",
    image:
      "https://res.cloudinary.com/dbb2hkjri/image/upload/v1793252607/7401c94c-82ea-4f46-a505-9403a9df8e2b_nmui0j.png",
  },
];
function formatDate(dateValue) {
  if (!dateValue) return "";

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}
function Blog() {
  const { accessToken, initializing } = useAuth();
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [blogs, setBlogs] = useState([]);
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    limit: 6,
    pages: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const blogsPerPage = 6;
  useEffect(() => {
    // Wait until AuthContext has attempted to restore the session.
    if (initializing) return;

    const controller = new AbortController();

    async function fetchBlogs() {
      setLoading(true);
      setError("");

      try {
        const params = new URLSearchParams({
          page: String(currentPage),
          limit: String(blogsPerPage),
          status: "published",
        });

        if (search.trim()) {
          params.set("search", search.trim());
        }

        const response = await fetch(
          `${API_BASE_URL}/api/v1/blogs?${params.toString()}`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              Accept: "application/json",
              ...(accessToken
                ? { Authorization: `Bearer ${accessToken}` }
                : {}),
            },
            signal: controller.signal,
          },
        );

        const result = await response.json().catch(() => ({}));

        if (!response.ok) {
          if (response.status === 401) {
            throw new Error(
              "Authentication failed. Please log in again or check whether this API requires a valid access token.",
            );
          }

          if (response.status === 403) {
            throw new Error("You do not have permission to view these blogs.");
          }

          throw new Error(
            result.message ||
              `Blogs load nahi hue. Server status: ${response.status}`,
          );
        }

        if (!result.success) {
          throw new Error(
            result.message || "Blogs fetch karne mein problem aayi.",
          );
        }

        const blogList = result.data?.blogs || [];
        const pageInfo = result.data?.pagination || {};

        setBlogs(blogList);

        setPagination({
          total: Number(pageInfo.total || 0),
          page: Number(pageInfo.page || currentPage),
          limit: Number(pageInfo.limit || blogsPerPage),
          pages: Number(pageInfo.pages || 0),
        });
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(err.message || "Blogs load karte waqt error aaya.");
          setBlogs([]);
          setPagination({
            total: 0,
            page: 1,
            limit: blogsPerPage,
            pages: 0,
          });
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    }
    fetchBlogs();
    return () => controller.abort();
  }, [accessToken, initializing, currentPage, search]);
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.pages) {
      setCurrentPage(page);

      document.querySelector(".blog-section")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  return (
    <>
      <Helmet>
        <title>Astrology & Vastu Blog: Tips, Insights & Remedies | Astro</title>
        <meta
          name="description"
          content="Explore astrology, Vastu, numerology, Rudraksha and spiritual insights. Discover practical tips, remedies and guidance to bring positivity and balance."
        />
        <link rel="canonical" href="https://astrologicalsolutions.in/Blog" />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Astrology & Vastu Blog: Tips, Insights & Remedies | Astro"
        />
        <meta
          property="og:description"
          content="Explore astrology, Vastu, numerology, Rudraksha and spiritual insights. Discover practical tips, remedies and guidance to bring positivity and balance."
        />
        <meta
          property="og:url"
          content="https://astrologicalsolutions.in/Blog"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Astro Logical Solutions" />
        <meta
          property="og:image"
          content="https://astrologicalsolutions.in/og/blog-cover.jpg"
        />
        <meta
          property="og:image:alt"
          content="Astrology, Vastu and spiritual insights from Astro Logical Solutions"
        />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Astrology & Vastu Blog: Tips, Insights & Remedies | Astro"
        />
        <meta
          name="twitter:description"
          content="Explore astrology, Vastu, numerology, Rudraksha and spiritual insights with practical tips and guidance."
        />
        <meta
          name="twitter:image"
          content="https://astrologicalsolutions.in/og/blog-cover.jpg"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            name: "Astrology & Vastu Blog",
            description:
              "Explore astrology, Vastu, numerology, Rudraksha and spiritual insights with practical tips and guidance.",
            url: "https://astrologicalsolutions.in/Blog",
            publisher: {
              "@type": "Organization",
              name: "Astro Logical Solutions",
              url: "https://astrologicalsolutions.in/",
            },
          })}
        </script>
      </Helmet>
      <Header />
      <section className="nrBlogWrapper">
        <div className="nrBlogContainer">
          <div className="nrBlogIntro">
            <div className="nrIntroCategories">
              <span>✣ Astrology</span>
              <span>|</span>
              <span>Rudraksha</span>
              <span>|</span>
              <span>Spirituality</span>
              <span>|</span>
              <span>Wellness</span>
            </div>

            <h1 className="nrBlogHeading">
              Insights from Astro Logical™ Solutions
            </h1>

            <p className="nrBlogSubHeading">
              Explore our latest articles on the spiritual, cultural, and
              healing aspects.
            </p>
          </div>
          <article className="nrFeaturedCard">
            <div className="nrImageBox">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/f_auto,q_auto,w_1600/v1791891527/beffdd10-176c-4d14-a6a6-abbafcd54ce0_n13ppj.png"
                alt="Rudraksha spiritual guidance"
              />

              <span className="nrFeaturedBadge">Featured</span>

              <div className="nrImageStats">
                <span>♥ 128</span>
                <span>▢ 24</span>
              </div>
            </div>
            <div className="nrFeaturedContent">
              <span className="nrTag">Rudraksha</span>
              <h2 className="nrFeaturedTitle">
                1 Mukhi Rudraksha: Who Should Wear It and Who Should Avoid It?
              </h2>
              <div className="nrMetaInfo">
                <span>▦ 13 Oct, 2026</span>
                <span>|</span>
                <span>♙ By Astro Logical Solutions</span>
              </div>
              <p className="nrDescription">
                1 Mukhi Rudraksha is one of the maximum spiritually good sized
                Rudraksha beads in the traditional Rudraksha gadget.
              </p>
              <a
                href="https://astrologicalsolutions.in/blog/8fba332c-eb5a-4b1a-b087-6e680add48da"
                className="nrReadMore"
              >
                Read Article <span>→</span>
              </a>
            </div>
          </article>
          <aside className="nrPopularSection">
            <div className="nrPopularHeader">
              <span className="nrCrown">♛</span>

              <div>
                <h2 className="nrPopularHeading">Popular Articles</h2>
                <p>Most viewed articles this month</p>
              </div>
            </div>

            <div className="nrPopularList">
              {popularBlogs.slice(0, 3).map((item, index) => (
                <a className="nrPopularCard" href={item.slug} key={item.id}>
                  <div className="nrPopularImage">
                    <img src={item.image} alt={item.title} loading="lazy" />
                  </div>
                  <div className="nrPopularContent">
                    <span className="nrPopularTag">{item.tag}</span>

                    <h3 className="nrPopularTitle">{item.title}</h3>

                    <div className="nrPopularMeta">
                      <span>
                        ◉ {item.views || ["12.4K", "9.8K", "7.6K"][index]} views
                      </span>
                      <span>♧ {item.date}</span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </aside>
        </div>
        <section className="featureStrip">
          <div className="featureContainer">
            {features.map((item, index) => (
              <div className="featureItem" key={index}>
                <div className="featureIcon">{item.icon}</div>

                <div className="featureText">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </section>
      <section className="blog-section">
        <div className="blog-header">
          <div className="blog-header-main">
            <h1 className="blog-heading">Spiritual Insights That Shine</h1>

            <div className="blog-heading-divider">
              <span></span>
              <span className="blog-divider-ornament">✧</span>
              <span></span>
            </div>

            <p className="blog-subheading">
              Discover powerful articles, timeless wisdom and practical guidance
              for a better life.
            </p>
          </div>

          <div className="blog-search">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search blogs..."
              value={search}
              onChange={handleSearchChange}
              aria-label="Search blogs"
            />
          </div>
        </div>

        <div className="blog-toolbar">
          <span className="blog-result-label">
            {search ? `Search results for "${search}"` : ""}
          </span>
        </div>

        {initializing || loading ? (
          <div className="blog-message">
            <p>Loading blogs...</p>
          </div>
        ) : error ? (
          <div className="blog-message" role="alert">
            <p>{error}</p>
            <button
              type="button"
              onClick={() => setCurrentPage((page) => page)}
            >
              Try Again
            </button>
          </div>
        ) : blogs.length === 0 ? (
          <div className="blog-message">
            <p>
              {search
                ? "No blogs found for your search."
                : "No published blogs are available yet."}
            </p>
          </div>
        ) : (
          <div className="blog-grid">
            {blogs.map((blog) => (
              <article className="blog-card" key={blog.id}>
                {blog.image && (
                  <Link
                    to={`/blog/${blog.id}`}
                    className="blog-image-link"
                    aria-label={`Read ${blog.title || "blog"}`}
                  >
                    <img
                      src={blog.image}
                      alt={blog.title || "Blog"}
                      loading="lazy"
                    />
                  </Link>
                )}

                <div className="blog-content">
                  <div className="blog-meta">
                    <span className="blog-category">
                      {blog.category || "Spiritual Insights"}
                    </span>

                    {blog.createdAt && (
                      <span className="blog-date">
                        {formatDate(blog.createdAt)}
                      </span>
                    )}
                  </div>

                  <h3>
                    <Link to={`/blog/${blog.id}`} className="blog-title-link">
                      {blog.title}
                    </Link>
                  </h3>

                  <p className="blog-description">
                    {blog.excerpt ||
                      blog.description ||
                      `Explore ${blog.title || "this article"} and discover useful spiritual insights, traditional wisdom and practical guidance...`}
                  </p>

                  <div className="blog-card-footer">
                    <Link to={`/blog/${blog.id}`} className="read-more-link">
                      Read Full Article <span>→</span>
                    </Link>

                    <div className="blog-social-actions">
                      <a
                        href={`https://wa.me/917351519573?text=Hello%20Astro%20Logical%20Solutions%2C%20I%20would%20like%20some%20guidance.`}
                        target="_blank"
                        rel="noreferrer"
                        className="social-icon social-whatsapp"
                        aria-label="Share on WhatsApp"
                      >
                        <i className="fa-brands fa-whatsapp">W</i>
                      </a>
                      <a
                        href={`https://www.instagram.com/astro.logicalsolutions`}
                        target="_blank"
                        rel="noreferrer"
                        className="social-icon social-whatsapp"
                        aria-label="Share on WhatsApp"
                      >
                        <i className="fa-brands fa-whatsapp">I</i>
                      </a>

                      <a
                        href={`https://www.facebook.com/share/1LpjJkShBa/`}
                        target="_blank"
                        rel="noreferrer"
                        className="social-icon social-facebook"
                        aria-label="Share on Facebook"
                      >
                        F{" "}
                      </a>

                      <button
                        type="button"
                        className="social-icon social-share"
                        aria-label="Copy article link"
                        onClick={() => {
                          navigator.clipboard?.writeText(
                            `${window.location.origin}/blog/${blog.id}`,
                          );
                        }}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          width="15"
                          height="15"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <circle cx="18" cy="5" r="3" />
                          <circle cx="6" cy="12" r="3" />
                          <circle cx="18" cy="19" r="3" />
                          <path d="m8.7 10.7 6.6-4.4M8.7 13.3l6.6 4.4" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}

        {!loading && !error && pagination.pages > 1 && (
          <div className="pagination">
            <button
              type="button"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage <= 1}
              aria-label="Previous page"
            >
              ‹
            </button>

            {Array.from(
              { length: pagination.pages },
              (_, index) => index + 1,
            ).map((page) => (
              <button
                type="button"
                key={page}
                className={currentPage === page ? "active" : ""}
                onClick={() => handlePageChange(page)}
                aria-current={currentPage === page ? "page" : undefined}
              >
                {page}
              </button>
            ))}

            <button
              type="button"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage >= pagination.pages}
              aria-label="Next page"
            >
              ›
            </button>
          </div>
        )}
      </section>
      <section className="spiritual-calculators">
        <div className="spiritual-calculators__container">
          <div className="spiritual-calculators__heading">
            <span className="spiritual-calculators__eyebrow">
              ✦ DISCOVER YOUR SPIRITUAL PATH ✦
            </span>

            <h2>Explore Our Spiritual Calculators</h2>

            <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Decorative divider"
              />
            </div>

            <p>
              Ancient wisdom, meaningful numbers, and personalized spiritual
              insights begin your journey of discovery.
            </p>
          </div>

          {/* Desktop grid and mobile slider */}
          <div className="spiritual-calculators__slider">
            <div className="spiritual-calculators__grid">
              {/* Rudraksha Calculator */}
              <article className="spiritual-calculator-card rudraksha-calculator">
                <div className="spiritual-calculator-card__top">
                  <div className="spiritual-calculator-card__icon">
                    <FaGem />
                  </div>

                  <span className="spiritual-calculator-card__number">01</span>
                </div>

                <span className="spiritual-calculator-card__tag">
                  SACRED BEAD DISCOVERY
                </span>

                <h3>Rudraksha Calculator</h3>

                <p>
                  Explore traditional Rudraksha guidance based on your birth
                  details and discover its spiritual significance.
                </p>

                <a
                  href="https://astrologicalsolutions.in/rudraksha-calculator"
                  className="spiritual-calculator-card__button"
                >
                  Explore Rudraksha <FaArrowRight />
                </a>

                <span className="spiritual-calculator-card__watermark">ॐ</span>
              </article>

              {/* Numerology Calculator */}
              <article className="spiritual-calculator-card numerology-calculator">
                <div className="spiritual-calculator-card__top">
                  <div className="spiritual-calculator-card__icon">
                    <FaCalculator />
                  </div>

                  <span className="spiritual-calculator-card__number">02</span>
                </div>

                <span className="spiritual-calculator-card__tag">
                  THE POWER OF NUMBERS
                </span>

                <h3>Numerology Calculator</h3>

                <p>
                  Discover traditional numerology interpretations connected with
                  your birth date and personal numbers.
                </p>

                <a
                  href="https://astrologicalsolutions.in/mobile-numerology"
                  className="spiritual-calculator-card__button"
                >
                  Calculate Your Numbers <FaArrowRight />
                </a>

                <span className="spiritual-calculator-card__watermark">
                  108
                </span>
              </article>
            </div>
          </div>

          {/* Mobile slider indicators */}
          <div className="spiritual-calculators__dots" aria-hidden="true">
            <span className="spiritual-calculators__dot spiritual-calculators__dot--active" />
            <span className="spiritual-calculators__dot" />
          </div>
        </div>
      </section>
      <section className="support-section">
        <div className="support-content">
          <h2>Need Support? Get Consultation Now!</h2>
          <p>Need to chat with us? We are happy to assist you.</p>

        <Link to="/contact" className="support-btn">
  <FiHeadphones />
  Get Support
</Link>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Blog;
